export const Free_Travel_TAG = 'https://p0.meituan.net/ingee/4ad3f2da9027bb06407addcdacc3f1441551.png';
export const GROUP_TOUR_TAG = 'https://p0.meituan.net/ingee/40160de6030f19501166ff9c01ba37dd2522.png';
export const DISCOUNT = 'https://p0.meituan.net/ingee/e6e9e90dd6528dfdabd7688c5a108905382.png';
export const CURVE = 'https://p0.meituan.net/ingee/f77eae1a9a01471bc446862eaae289ab415.png';
export const MORE_BTN = 'https://p0.meituan.net/ingee/517bb20eab3ff3075214b115ed91a0524415.png';
export const isTest = () => { var _a, _b; return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host.indexOf('.test.')) > 0 || ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.host.indexOf('.dev.')) > 0; };
export const locationIconImage = 'https://p0.meituan.net/ingee/7c9aa6ad322b1f5245d8fceaec42ebc0483.png';
export const travelDaysTagImages = {
    '1天': 'https://img.meituan.net/makerjiulv/78891cb2ed1c760209df297af9d01ff81608.png',
    '2天': 'https://img.meituan.net/makerjiulv/4566fad9a310f93eb0ce8ea85f8cbf4e9401.png',
    '3天': 'https://img.meituan.net/makerjiulv/1bd794d6a7f8f659ac71f4c2ca794cf12164.png',
    '4天': 'https://img.meituan.net/makerjiulv/a847f2204bbca5c30f4ec6fecc4976c31856.png',
    '5天': 'https://img.meituan.net/makerjiulv/fe6070b3066238cdc1211142cbfe969d1440.png',
    '6天': 'https://img.meituan.net/makerjiulv/c5738652063e2d22618f150ec40e095a1540.png',
    '7天': 'https://img.meituan.net/makerjiulv/c3fdc4b39bbb6c03f740060d3a73d0dd1317.png',
    '8天': 'https://img.meituan.net/makerjiulv/59883c631bfdefaae98f0edf3597d4371530.png',
    '9天': 'https://img.meituan.net/makerjiulv/09fd0734d1a888d7bcd28f74a48e794f1526.png'
};
export const TAG_IMAGE_MAP = {
    SMALL_GROUP_TOUR_TAG: {
        image: 'https://p0.meituan.net/ingee/4485f1ef016f77052799577256ba677f2274.png',
        width: 72,
        title: '小团游'
    },
    CHARTET_CAR_TOUR_TAG: {
        image: 'https://p0.meituan.net/ingee/b64407c6b93c66205dace36805d834aa2291.png',
        width: 72,
        title: '包车游'
    },
    FAMILY_EXCLUSIVE_TAG: {
        image: 'https://p0.meituan.net/ingee/5beae1fd672923acbeee2bfde4787ea73319.png',
        width: 112,
        title: '家庭独享团'
    },
    OUTDOOR_HIKING_TAG: {
        image: 'https://p0.meituan.net/ingee/1a8cc4a356fd400e5efb41aab44bb91c2662.png',
        width: 90,
        title: '户外徒步'
    },
    CLASSIC_LARGE_GROUP_TAG: {
        image: 'https://p0.meituan.net/ingee/db646a58035e819c0ca90f119008c5992711.png',
        width: 90,
        title: '经典大团'
    },
    TICKET_HOTEL_TAG: {
        image: 'https://p0.meituan.net/ingee/ccd70aebe42ce27a53c45e1d9061696e2361.png',
        width: 105,
        title: '门票+住宿'
    },
    TRAVEL_PACKAGE_TAG: {
        image: 'https://p0.meituan.net/ingee/023f171e12352d196fd0ad148dd399ac3682.png',
        width: 90,
        title: '旅游套餐'
    }
};
export const MAGIC_COUPLE_ICON = 'https://p0.meituan.net/ingee/bc37e253e2b8c1c618c87795ef3b2b902408.png';
